import { useState, useEffect, useCallback } from 'react';
import { fetchFunnelData, fetchLeadSources } from '~/services/analytics';
import type { IDateRange, IFunnelStage, ILeadSourceRow } from '~/types';

export function useFunnelData(dateRange: IDateRange) {
  const [loading, setLoading] = useState(true);
  const [stages, setStages] = useState<IFunnelStage[]>([]);
  const [leadSources, setLeadSources] = useState<ILeadSourceRow[]>([]);
  const [leadSourceTotal, setLeadSourceTotal] = useState(0);
  const [leadSourcePage, setLeadSourcePage] = useState(1);

  const loadFunnel = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchFunnelData(dateRange);
      setStages(data);
    } catch (err) {
      console.error('Funnel data error:', err);
    } finally {
      setLoading(false);
    }
  }, [dateRange]);

  const loadLeadSources = useCallback(async () => {
    try {
      const { rows, total } = await fetchLeadSources(dateRange, leadSourcePage);
      setLeadSources(rows);
      setLeadSourceTotal(total);
    } catch (err) {
      console.error('Lead source data error:', err);
    }
  }, [dateRange, leadSourcePage]);

  useEffect(() => {
    loadFunnel();
  }, [loadFunnel]);

  useEffect(() => {
    loadLeadSources();
  }, [loadLeadSources]);

  return {
    loading,
    stages,
    leadSources,
    leadSourceTotal,
    leadSourcePage,
    setLeadSourcePage,
  };
}
